import { forwardRef, type ReactNode } from 'react';
import { Button as BSButton, type ButtonProps as BSButtonProps } from 'react-bootstrap';
import './Button.scss';

export interface ButtonProps extends BSButtonProps {
    leftIcon?: ReactNode;
    rightIcon?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ leftIcon, rightIcon, children, ...props }, ref) => {
    return (
        <BSButton ref={ref} {...props}>
            {leftIcon && <span className="btn-icon-left">{leftIcon}</span>}
            {children}
            {rightIcon && <span className="btn-icon-right">{rightIcon}</span>}
        </BSButton>
    );
});

Button.displayName = 'Button';
